<div class="form-group">
    <div class="checkbox">
        <input type="checkbox" id="checkbox-boolean-filter-{{ key }}" [(ngModel)]="value" (ngModelChange)="filter()">
        <label for="checkbox-boolean-filter-{{ key }}">{{ label }}</label>
    </div>
</div>
